import React from 'react';
import { withRouter } from "react-router";
import Tabs from '../../layouts/Tabs';
import { getTabIndex } from '../../utils';
import CompanyLibrary from './CompanyLibrary';
import IndividualCoachLibrary from './IndividualCoachLibrary';
import { connect } from 'react-redux';

const baseRoute = '/digital-coaching';
const DigitalCoaching = ({
  match,
  location,
  authState,
  history,
  ...other
}) => {

  const tabs = [
    {
      label: 'Individual Coaching',
      component: <IndividualCoachLibrary history={history}  {...other} />,
      path: `${baseRoute}/individual-coaching/`
    },
  ];

  if (authState?.userData && authState?.userData?.is_staff) {
    tabs.unshift({
      label: 'Companies',
      component: <CompanyLibrary history={history}  {...other} />,
      path: `${baseRoute}`
    })
  }

  return (
    <Tabs
      key={`guide-${location.pathname}`}
      value={getTabIndex(match.url, tabs)}
      tabComponents={tabs}
    />
  )
}

const mapStateToProps = (state) => ({
  authState: state.authState
})

export default withRouter(connect(mapStateToProps)(DigitalCoaching));
